<ion-card-content class="ion-padding-horizontal-2 ion-padding-vertical-0">
    <app-single-user-select *ngIf="!to.multi" [scannedAsset]="users[0]" [props]="$any(props)" [key]="updatedKey"
        (usersEvent)="saveUsers($event)">
    </app-single-user-select>

    <app-multi-user-select *ngIf="to.multi" [scannedAssets]="users" [props]="$any(props)" [key]="updatedKey"
        (usersEvent)="saveUsers($event)">
    </app-multi-user-select>

</ion-card-content>